var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dd-container home"},[_c('Banner'),_vm._v(" "),_c('News')],1)}
var staticRenderFns = []

export { render, staticRenderFns }